import React from "react";
import "./HouseAdCard.css";

const HouseAdCard = ({ houseAd = null, placement = "regular", onClick }) => {
  const placementEnabled =
    placement === "first"
      ? houseAd?.firstEnabled === true
      : houseAd?.regularEnabled === true;

  if (
    !houseAd?.enabled ||
    !placementEnabled ||
    !houseAd?.targetUrl ||
    !houseAd?.title ||
    !houseAd?.ctaLabel
  ) {
    return null;
  }

  return (
    <a
      className="house-ad-card"
      href={houseAd.targetUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      aria-label={`${houseAd.title}؛ ${houseAd.ctaLabel}`}
      data-ad-banner-type="house"
      data-house-ad-placement={placement}
      data-house-ad-version={houseAd.version || undefined}
    >
      <span className="house-ad-card__copy">
        <strong className="house-ad-card__title">{houseAd.title}</strong>
        {houseAd.subtitle && (
          <span className="house-ad-card__subtitle">{houseAd.subtitle}</span>
        )}
      </span>

      <span className="house-ad-card__cta" aria-hidden="true">
        {houseAd.ctaLabel}
      </span>
    </a>
  );
};

export default HouseAdCard;
